import { EismItem, PageWrapper } from '@src/components';
import { useLazyGetCurrentEsimsQuery } from '@src/services/esim/esimApiSlice';
import { useEffect } from 'react';
import { EmptyList } from './EmptyList';
import { CardsSkeleton } from '@src/components/Loading/CardsSkeleton';

export function CurrentView() {
  const [getMyCurrentEsims, { data: esims, isLoading }] =
    useLazyGetCurrentEsimsQuery();

  useEffect(() => {
    getMyCurrentEsims();
  }, []);

  if (isLoading) return <CardsSkeleton numberOfItems={2} />;

  return (
    <PageWrapper>
      {esims?.length ? (
        <div className='grid gap-4 lg:grid-cols-3'>
          {esims.map((esim) => {
            return <EismItem mode='current' key={esim.esimId} esim={esim} />;
          })}
        </div>
      ) : (
        <EmptyList />
      )}
    </PageWrapper>
  );
}
